export enum SuggestionAffair {
  SERVICE_IMPROVEMENT = 'SERVICE_IMPROVEMENT',
  SIGN_UP_AND_LOG_IN = 'SIGN_UP_AND_LOG_IN',
  VEHICLE_CONDITIONS = 'VEHICLE_CONDITIONS',
  DRIVER = 'DRIVER',
  BOOKING_PROCESS = 'BOOKING_PROCESS',
  OTHERS_ABOUT_APP = 'OTHERS_ABOUT_APP',
  BACKOFFICE = 'BACKOFFICE',
  OTHERS = 'OTHERS',
}
